/**
 * mod by caozh on 2018/5/31.
 */
;(function () {

    uploadPicCtrl.$inject = ['$timeout', '$scope', 'UploaderService', '$q'];
    angular
        .module('DSSXAPP')
        .component('uploadLocalPic', {
            template:'<div class="upload-local-pic-container"><div class="head">从我的电脑选择图片 <span class="close-btn" ng-click="vm.f.close()">×</span></div><div class="tips-block"><div><span>选择分组</span></div><div>单张不超过3M,支持Jpeg，Jpg，Png，建议尺寸小于1000px*1000px。图片名称只允许输入英文、中文和数字。</div></div><div id="content"><progress max="100"></progress><div id="uploadPic-images-block" class="images-block"><div class="new-img" ng-repeat="($index, item) in vm.d.files"><div class="img" style="background-image: url({{item.url}});"><img src="../../../../images/product-post/uploader-bg.png" ng-show="item.status !== \'uploaded\'"> <span class="progress" ng-style="{width: item.style.width}" ng-show="item.progress.loadedSize < item.progress.totalSize"></span> <span style="position: absolute;top: 50%;left: 50%;transform: translate(-50%);cursor: pointer;color: #2192D9;" ng-show="item.status === \'uploading\' || item.status === \'beUpload\'" ng-click="vm.f.cancelUpload(item.id, $index)">取消</span> <a href="{{item.downlink}}" download class="iconfont icon-icondownload" ng-show="item.status === \'uploaded\'"></a> <i class="iconfont icon-delete" ng-show="item.status === \'uploaded\'" ng-click="vm.f.removeNewImg($index)"></i></div><p>{{item.name}}</p></div><div id="sel-pic" class="add-img" ng-click="vm.f.showLocalFile()"><span>+</span> <span>上传图片</span></div></div><div><input type="checkbox"> <span class="msg-title">压缩图片至推荐画质（以提升旺铺性能）</span></div><div class="uploadPic-handle-block"><button class="op-btn submit-btn" ng-class="{disabled: vm.d.files.length <= 0 || !vm.d.canSendPicToEditor}" ng-disabled="vm.d.files.length <= 0 || !vm.d.canSendPicToEditor" ng-click="vm.f.sendPicToEditor()">确认上传</button> <button class="op-btn close-btn" ng-click="vm.f.close()">取消</button> <span>（已选择 <span>{{vm.d.files.length}}</span> / <span>{{vm.d.picCount}}</span>）</span></div></div><input type="file" id="contact-file-upload-btn" multiple file-upload="vm.f.uploader($event)" accept="image/png, image/jpg, image/jpeg" style="display: none"></div>',
            bindings: {
                show: '=', // 是否显示该组件
                picCount: '<', // 可以上传的图片张数
            },
            controllerAs: 'vm',
            controller: uploadPicCtrl
        })

    function uploadPicCtrl($timeout, $scope, UploaderService, $q) {

        var vm = this

        vm.d = {
            errList: [],
            files: [],
            supportType: ['jpg', 'jpeg', 'png'],
            picCount: null,
            canSendPicToEditor: true
        }

        vm.f = {
            close: close,
            showLocalFile: showLocalFile,
            uploader: uploader,
            removeNewImg: removeNewImg,
            sendPicToEditor: sendPicToEditor,
            cancelUpload: cancelUpload,
        }

        onInit();

        function onInit() {
            initScopeWatch();
        }

        // 监听参数
        function initScopeWatch() {
            $scope.$watch("vm.show", function (nv, ov) {
                if (nv) {
                    uploadPicIndex = layer.open({
                        type: 1,
                        title: false,
                        closeBtn: 0,
                        area: ["938px", "500px"],
                        content: $('.upload-local-pic-container'),
                        cancel: function () {
                            vm.f.close()
                        }
                    });
                }
            })
            $scope.$watch("vm.picCount", function (nv, ov) {
                if (nv) {
                    vm.d.picCount = vm.picCount
                }
            })
            $scope.$watch("vm.d.files", function (nv, ov) {
                if (nv) {
                    var hasUplaodingFile = false
                    vm.d.files.forEach(function (v) {
                        if (v.status === 'beUpload' || v.status === 'uploading') {
                            hasUplaodingFile = true
                        }
                    })
                    if (hasUplaodingFile) {
                        vm.d.canSendPicToEditor = false
                    } else {
                        vm.d.canSendPicToEditor = true
                    }
                }
            }, true)
        }

        // 关闭弹出层
        function close() {
            hideUploadComponent();
            // 初始化数据
            vm.d.errList = []
            vm.d.files = []
            layer.close(uploadPicIndex);
        }

        // 改变layer显示状态
        function hideUploadComponent() {
            $timeout(function () {
                vm.show = false;
            })
        }

        // 显示本地文件
        function showLocalFile() {
            if (vm.d.files.length < vm.d.picCount) {
                $('#contact-file-upload-btn').click()
            }else {
                layer.msg('不能上传超过'+vm.d.picCount+'张图片');
            }
        }

        // 文件上传
        function uploader(e) {
            $('#contact-file-upload-btn').val('');
            // 文件校验 剔除不合格的文件
            var files = getValidFiles(e.files);

            for (var i = 0; i < files.length; i++) {
                startUpload(files[i]);
            }
        }
        function getValidFiles(files) {
            var list = [];
            vm.d.errList = [];
            files.forEach(function (item) {
                var
                    msg,
                    index = item.name.lastIndexOf('.'),
                    type = item.name.slice(index + 1)
                ;

                if (vm.d.supportType.indexOf(type) === -1) {
                    msg = item.name + ' 文件类型错误，支持文件类 jpg,jpeg,png;';
                    vm.d.errList.push(msg);
                    layer.msg(msg);
                } else if (item.size > 1024*1024*3) {
                    msg = '文件大小不能超过3M';
                    vm.d.errList.push(msg);
                    layer.msg(msg);
                } else {
                    list.push(item);
                }
            })

            return list;
        }

        // 开始上传
        function startUpload(file) {
            var info = {};
            beStart();
            UploaderService.start(file, info, progressChangeCB)
                .then(uploaderSuc, uploaderErr);

            function beStart() {
                var
                    index = file.name.lastIndexOf('.'),
                    type = file.name.slice(index + 1)
                ;

                info = {
                    name: file.name,
                    status: 'beUpload',
                    progress: {
                        totalSize: file.size,
                        loadedSize: 0
                    },
                    style: {},
                    fileClassName: getFileIcon(type)
                };

                vm.d.files.push(info);

                function getFileIcon(type) {
                    switch (type) {
                        case 'jpg':
                            return 'icon-file-jpg';
                        case 'jpeg':
                            return 'icon-file-jpg';
                        case 'png':
                            return 'icon-file-png';
                        case 'gif':
                            return 'icon-file-gif';
                        case 'doc':
                            return 'icon-file-doc';
                        case 'docx':
                            return 'icon-file-doc';
                        case 'xls':
                            return 'icon-file-xls';
                        case 'xlsx':
                            return 'icon-file-xls';
                        case 'ppt':
                            return '';
                        case 'pptx':
                            return '';
                        case 'pdf':
                            return 'icon-file-pdf';
                        default:
                            return '';
                    }
                }
            }

            function uploaderSuc(res) {
                var
                    files = vm.d.files,
                    name = res.base.name
                ;

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    if (file.id === res.id) {
                        file.status = 'uploaded';
                        file.url = res.data;
                        file.downlink = res.data + '?attachment=' + name + '&dl=1&filename=' + name;
                        break;
                    }
                }
                console.log(vm.d.files)
            }

            function uploaderErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'uploadPic.js',
                    funcName: 'startUpload',
                    text: 'startUpload fail'
                });
                $q.reject(err);
            }

            function progressChangeCB(file) {
                var
                    loadedSize = file.progress.loadedSize,
                    totalSize = file.progress.totalSize,
                    progressPercent = Math.round(loadedSize * 100 / totalSize)
                ;

                file.style = {
                    width: progressPercent + '%'
                };
            }
        }

        // 删除已上传的图片
        function removeNewImg(index) {
            $timeout(function () {
               vm.d.files.splice(index, 1)
            }, 0)
        }

        // 将上传的图片显示到编辑器当中
        function sendPicToEditor() {

            if (!vm.d.canSendPicToEditor) {
                return;
            }

            if (vm.d.files.length <= vm.d.picCount) {
                var picArr = []
                vm.d.files.forEach (function (item) {
                    picArr.push(item.downlink)
                })
                DSSX.customEditorUploaderPichandler.onSuccess(picArr)
                close()
            }else {
                layer.msg('不能上传超过'+vm.d.picCount+'张图片');
            }
        }

        // 取消上传图片
        function cancelUpload(id, index) {
            UploaderService.cancel(id);
            vm.d.files.splice(index, 1)
        }

    }
})()